<script>
import BaseIcon from '../_base-icon.vue'

export default {
    name: 'SimpleMessageModal',

    components: {
        BaseIcon,
    },

    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        headline() {
            return this.data.headline || 'Message'
        },
        message() {
            return this.data.message || ''
        },
    },

    methods: {
        close() {
            if (this.data.onClose) {
                this.data.onClose()
            }
            this.$emit('close')
        },
    },
}
</script>

<template>
    <div :class="$style.modal">
        <button
            :class="$style.closeButton"
            aria-label="Close modal"
            @click="close"
        >
            <BaseIcon
                :class="$style.closeIcon"
                name="close-outline"
            />
        </button>

        <div :class="$style.content">
            <h5 :class="$style.headline">
                {{ headline }}
            </h5>
            <p :class="$style.message">
                {{ message }}
            </p>
        </div>
    </div>
</template>

<style module lang="scss">
@use '@design' as *;

.modal {
    position: relative;
    width: 90vw;
    max-width: 500px;
    padding: $s-h 64px 48px;
    background: #27292D;
    border: none;
    border-radius: 12px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.95);

    @include mobileOnly {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc(100vw - $s-xxl);
        max-width: none;
        height: auto;
        padding: $s-xxl 30px 36px;
        margin: $s-l;
        border-radius: $s-m;
    }
}

.closeButton {
    position: absolute;
    top: $s-l;
    right: $s-l;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: $s-xxs;
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    background: transparent;
    border: none;
    border-radius: 50%;
    transition: all 0.2s ease;

    .closeIcon {
        width: $s-l;
        height: $s-l;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.8);
        background: rgba(255, 255, 255, 0.08);
    }

    @include mobileOnly {
        top: $s-l;
        right: $s-l;
    }
}

.content {
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
    text-align: left;
}

.headline {
    @extend %h5;

    margin: 0;
    margin-bottom: $s-m;
    color: $c-white;

    @include mobileOnly {
        margin-bottom: $s-s;
    }
}

.message {
    @extend %p;

    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);

    @include mobileOnly {
        font-size: 14px;
    }
}
</style>
